import css from "./css/imageWithText.module.css"
import { findContentByLabel } from "../utils/findContentByLabel"

const ImageWithText = ({ data }) => {
  const checklistText = findContentByLabel(data, "section1_checklist") || ""
  const checklist = checklistText ? checklistText.split("\n").filter(item => item.trim()) : [
    "免TU 過往信貸不影響申請",
    "24/7即時過數",
    "特快網上貸款體驗"
  ]

  return (
    <div className={css.container}>
      <ul className={css.textOverlay}>
        {checklist.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  )
}

export default ImageWithText
